import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, LogOut, SlidersHorizontal } from "lucide-react";
import { useAuth } from "../shared/auth";
import { humanError } from "../shared/api";
import { translate as tr, useI18n } from "../shared/i18n";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

export function AccountMenu({ onError }: { onError: (message: string) => void }) {
  const { user, logout, hasPermission } = useAuth();
  const { t } = useI18n();
  const [pending, setPending] = useState(false);
  const name = [user?.first_name || user?.username, user?.last_name].filter(Boolean).join(" ");
  const role = tr(user?.role_names[0] ?? "Пользователь");
  const signOut = async () => {
    setPending(true);
    onError("");
    try { await logout(); }
    catch (error) { onError(humanError(error)); }
    finally { setPending(false); }
  };
  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" className="h-10 shrink-0 gap-2 px-1.5 sm:px-2" aria-label={tr("Меню пользователя")} disabled={pending}>
        <Avatar className="size-8"><AvatarFallback className="bg-secondary text-xs text-primary">{(user?.first_name?.[0] || user?.username?.[0] || "LT").toUpperCase()}</AvatarFallback></Avatar>
        <span className="hidden max-w-36 flex-col items-start text-left min-[1100px]:flex"><span className="w-full truncate text-xs font-semibold">{name}</span><span className="w-full truncate text-[11px] font-normal text-muted-foreground">{role}</span></span>
        <ChevronDown className="hidden size-3.5 text-muted-foreground sm:block"/>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" sideOffset={8} className="w-64 max-w-[calc(100vw-2rem)]">
      <DropdownMenuLabel className="space-y-1 px-3 py-2"><div className="break-words">{name}</div><div className="break-words text-xs font-normal text-muted-foreground">{role}</div></DropdownMenuLabel>
      <DropdownMenuSeparator/>
      {user?.work_profile !== "cap_orders" && hasPermission("settings.view") && <DropdownMenuItem asChild><Link to="/settings"><SlidersHorizontal/>{t("settings")}</Link></DropdownMenuItem>}
      <DropdownMenuItem variant="destructive" disabled={pending} onSelect={() => { void signOut(); }}><LogOut/>{t("logout")}</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>;
}
